import { type StoryblokProductSearchFilterOwnBrandsType } from '../../../../storyblok'
import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

import { storyblokProductSearchFiltersGetValuesFromString } from './storyblokProductSearchFiltersGetValuesFromString'

export const storyblokProductSearchFiltersGetCategoriesOwnBrands = (
  categoryOwnBrands: StoryblokProductSearchFilterOwnBrandsType,
): Partial<
  Pick<StoryblokProductSearchFiltersType, 'brandCode' | 'categoryCodes'>
> => {
  return {
    brandCode: storyblokProductSearchFiltersGetValuesFromString(
      categoryOwnBrands.brandIds,
    ),
    categoryCodes: storyblokProductSearchFiltersGetValuesFromString(
      categoryOwnBrands.categoryIds,
    ),
  }
}
